import {AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
    LeftpanelComponent,
} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {Router} from '@angular/router';
import {SchedulerListenerService} from '../scheduler-listener.service';
import {environment} from '../../environments/environment';

declare let $;

@Component({
    selector: 'app-trigger',
    templateUrl: './trigger.component.html',
    styleUrls: ['./trigger.component.scss']
})
export class TriggerComponent implements OnInit {

    @Input() configurationObject: any;
    @Input() name: any;
    @Input() version: any;
    @Input() jobName = '';
    @Input() jobDescription = '';
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() pkey = localStorage.getItem('partnerKey');
    @Input() apikey = localStorage.getItem('apikey');
    @Input() mode = '';
    @Input() wholeDataToReschedule: any;
    @Input() startDateActualFormat: any;
    @Input() endDateActualFormat: any;

    @Output() close: EventEmitter<any> = new EventEmitter();

    @ViewChild('dt1') intervalStartDate: ElementRef;
    @ViewChild('dt2') intervalEndDate: ElementRef;


    scheduledJobs: any;
    executors: any;
    executorsDropdown = [];
    progressLoading = false;
    selectedExecutor = [];

    settings = {
        text: 'Select APIs to Trigger',
        singleSelection: false,
        enableSearchFilter: true,
        position: 'bottom',
        itemsShowLimit: 3,
        maxHeight: 160,
        enableCheckAll: false,
        badgeShowLimit: 3
    };

    constructor(private platform: LeftpanelComponent, private confPost: ConfService, private dialog: MatDialog, private router: Router, private schedulerListenerInstance: SchedulerListenerService) {
    }

    async ngOnInit() {

        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        if (this.platform.leftpanelData) {
            this.executors = this.platform.leftpanelData;
        } else {
            await this.platform.getExecutorsForPartnerAccount();
            this.executors = this.platform.leftpanelData;
        }
        this.selectedExecutor = [];
        if (this.executors) {
            for (let i = 0; i < this.executors.length; i++) {
                if (this.executors[i] && this.executors[i]['executor_type'] !== 'API') {
                    const tempObj = {};
                    tempObj['id'] = i;
                    tempObj['itemName'] = this.executors[i]['executor_name'] + ' (' + this.executors[i]['executor_version'] + ')';
                    this.executorsDropdown.push(tempObj);
                    if (this.mode === 'edit-trigger' && this.wholeDataToReschedule.hasOwnProperty('executors') && this.wholeDataToReschedule.executors.length > 0) {
                        for (const item2 of this.wholeDataToReschedule.executors) {
                            if (item2['source_model']['executor_name'] === this.executors[i]['executor_name'] && item2['source_model']['executor_version'] === this.executors[i]['executor_version']) {
                                this.selectedExecutor.push(tempObj);
                            }
                        }
                    } else {
                        if (this.executors[i]['executor_name'] === this.name && this.executors[i]['executor_version'] === this.version) {
                            this.selectedExecutor.push(tempObj);
                        }
                    }
                }
            }
        }
    }

    scheduleJob() {
        if (this.jobName !== '' && this.jobName !== null && this.jobName !== undefined) {
            // this.constructPayloadAndSchedule();
            if (this.selectedExecutor.length > 0) {
                let temp = [];
                for (const item of this.selectedExecutor) {
                    const executorSplit = item['itemName'].split(' (');
                    const tempName = executorSplit[0];
                    const tempVersion = executorSplit[1].substr(0, executorSplit[1].length - 1);
                    for (const exec of this.executors) {
                        if (tempName === exec.executor_name && tempVersion === exec.executor_version) {
                            const obj = {
                                'type': 'api',
                                'name': exec.executor_name,
                                'source_model': exec
                            };
                            temp.push(obj);
                        }
                    }
                }
                const payload = {
                    partner: this.partner,
                    account: this.account,
                    significance: 'generate',
                    intent: 'triggers',
                    data: {
                        trigger_name: this.jobName,
                        description: this.jobDescription,
                        executors: temp
                    },
                    servers: {
                        services: 'services.apiplatform.io',
                        kinger: 'kinger-services.apiplatform.io',
                        kong: 'admin.gateway.apiplatform.io',
                        'python-services': 'servicesv2.apiplatform.io'
                    }
                };
                // console.log('payload',payload);
                this.progressLoading = true;
                this.confPost.postCoreApi(environment.coreAPI.trigger.name, environment.coreAPI.trigger.version, payload).subscribe(data => {
                    const res = data;
                    this.progressLoading = false;
                    this.platform.openSnackBar('Trigger created successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.close.emit();
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while creating trigger.');
                });
            } else {
                this.platform.openSnackBar('Please select APIs to trigger.', 'Error', {
                    duration: 7000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }

        } else {
            this.platform.openSnackBar('Please enter a trigger name.', 'Error', {
                duration: 7000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    updateJob() {

        if (this.jobName !== '' && this.jobName !== null && this.jobName !== undefined) {
            // this.constructPayloadAndSchedule();
            if (this.selectedExecutor.length > 0) {
                let temp = [];
                for (const item of this.selectedExecutor) {
                    const executorSplit = item['itemName'].split(' (');
                    const tempName = executorSplit[0];
                    const tempVersion = executorSplit[1].substr(0, executorSplit[1].length - 1);
                    for (const exec of this.executors) {
                        if (tempName === exec.executor_name && tempVersion === exec.executor_version) {
                            const obj = {
                                'type': 'api',
                                'name': exec.executor_name,
                                'source_model': exec
                            };
                            temp.push(obj);
                        }
                    }
                }
                const payload = {
                    partner: this.partner,
                    account: this.account,
                    significance: 'refurbish',
                    intent: 'triggers',
                    data: {
                        trigger_name: this.jobName,
                        description: this.jobDescription,
                        executors: temp
                    },
                    servers: {
                        services: 'services.apiplatform.io',
                        kinger: 'kinger-services.apiplatform.io',
                        kong: 'admin.gateway.apiplatform.io',
                        'python-services': 'servicesv2.apiplatform.io'
                    }
                };
                // console.log('payload',payload);
                this.progressLoading = true;
                this.confPost.postCoreApi(environment.coreAPI.trigger.name, environment.coreAPI.trigger.version, payload).subscribe(data => {
                    const res = data;
                    this.progressLoading = false;
                    this.platform.openSnackBar('Trigger updated successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.close.emit();
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while creating trigger.');
                });
            } else {
                this.platform.openSnackBar('Please select APIs to trigger.', 'Error', {
                    duration: 7000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }

        } else {
            this.platform.openSnackBar('Please enter a trigger name.', 'Error', {
                duration: 7000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }
}
